export const purchasesConstants = {
    PURCHASE_LOADING: "PURCHASE_LOADING",
    PURCHASE_PROCESSING: "PURCHASE_PROCESSING",
    PURCHASE_SUCCESS: "PURCHASE_SUCCESS",
    PURCHASE_CANCELED: "PURCHASE_CANCELED",
    PURCHASE_ERROR: "PURCHASE_ERROR",
    CLEAR: "CLEAR",
};